import React from 'react';
import { pdf, Font, Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import cl from './Underwriters.module.css';
import PDFicon from "../../../../assets/Icon/SheildCheck";
import HelveticaBold from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-75Bd.ttf'; 
import HelveticaRd from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-55Rm.ttf';  
import { useTranslation } from 'react-i18next';

Font.register({
    family: 'HelveticaRd',  
    src: HelveticaRd, 
});

Font.register({
    family: 'HelveticaBold', 
    src: HelveticaBold, 
});

const styles = StyleSheet.create({
    page: {
        fontFamily: 'HelveticaRd', 
        backgroundColor: '#FFF',
        padding: '40px 50px',
        fontSize: '10px',
        lineHeight: 1.5, 
        textAlign: 'justify',
    }, 
    p: { 
        marginBottom: '10px',
        textAlign: 'justify',
    }, 
    b: { 
        fontFamily: 'HelveticaBold', 
    },
    sectionTitle: {
        fontFamily: 'HelveticaBold',
        textAlign: 'center',
        marginBottom: '15px',
        marginTop: '20px'
    },
    clauseNumber: {
        maxWidth: 15,
        minWidth: 15,
        marginRight: 8
    }
});

const MyDocument = () => (
    <Document>
        <Page size="A4" style={styles.page}>
            <View style={{fontFamily: 'HelveticaBold', textAlign: 'right', marginBottom: '20px'}}>
                <Text>დანართი N1</Text> 
            </View>

            <View style={styles.sectionTitle}>
                <Text>INSTITUTE OF LONDON UNDERWRITERS</Text>
                <Text>ლონდონის მზღვეველთა ინსტიტუტი</Text>
                <Text>ტვირთის დაზღვევის პირობები A(A)</Text>
                <Text>ყველა რისკისგან დაზღვევა</Text>
            </View>

            <View style={styles.sectionTitle}>
                <Text>დაზღვეული რისკები</Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>1.</Text>
                <Text>
                    ეს დაზღვევა ფარავს დაზღვეული ობიექტის დანაკარგის ან დაზიანების ყველა რისკს, გარდა ქვემოთ, 4, 5, 6 და 7 მუხლებით გათვალისწინებული შემთხვევებისა.
                </Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>2.</Text>
                <Text>
                    ეს დაზღვევა შესაბამისი პროპორციით ფარავს სატრანსპორტო საშუალებისა და მასზე განლაგებული ყველა ტვირთისადმი საერთო ავარიის დროს მიყენებული ზიანისა და ამ ტვირთების გადარჩენის ხარჯებს, დაზუსტებულს და განსაზღვრულს სატრანსპორტო გადაზიდვის ხელშეკრულებით და/ან მოქმედი კანონმდებლობითა და პრაქტიკით, რომლებიც გაწეულია ნებისმიერი მიზეზით გამოწვეული ზიანის თავიდან ასაცილებლად ან თავიდან აცილებასთან დაკავშირებით, გარდა მე-4, მე-5, მე-6 და მე-7 მუხლებით გათვალისწინებული ან ამ დაზღვევის პირობებით განსაზღვრული ნებისმიერი სხვა გამონაკლისი შემთხვევებისა.
                </Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>3.</Text>
                <Text>
                    ამ დაზღვევით იფარება აგრეთვე დამზღვევის პასუხისმგებლობის ის ნაწილი, რომელიც გათვალისწინებულია საფრახტო ხელშეკრულების “ორმხრივი ბრალეულობით გამოწვეული შეჯახების” პირობით, და ანაზღაურდება იმავე პროპორციით, როგორც ამ პირობებით ანაზღაურებადი ზარალი. გემთმფლობელის მიერ აღნიშნული პირობის მიხედვით ნებისმიერი სარჩელის აღძვრის შემთხვევაში დაზღვეულმა უნდა შეატყობინოს მზღვეველს ამის შესახებ. მზღვეველი უფლებამოსილი იქნება საკუთარი ხარჯებით დაიცვას დაზღვეული ასეთი სარჩელისგან.
                </Text>
            </View>

            <View style={styles.sectionTitle}>
                <Text>გამონაკლისები</Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>4.</Text>
                <Text>
                    4.1 დანაკარგს, დაზიანებას ან ხარჯს, რომელიც დაკავშირებულია დაზღვეულის მიერ განზრახ ქმედებასთან ან უხეშ გაუფრთხილებლობასთან
                    {"\n"}4.2 ტვირთის წონის ან მოცულობის კლებას ან ცვეთას, მისთვის დამახასიათებელი თვისებიდან გამომდინარე
                    {"\n"}4.3 დანაკარგს, დაზიანებას ან ხარჯს, გამოწვეულს ტვირთის არასათანადო შეფუთვით ან მომზადებით
                    {"\n"}4.4 დანაკარგს, დაზიანებას ან ხარჯს, გამოწვეულს დაზღვეული ტვირთის წუნით ან მისი დამახასიათებელი თვისებებით
                    {"\n"}4.5 დანაკარგს, დაზიანებას ან ხარჯს, რომელიც უშუალოდ არის გამოწვეული ტრანსპორტირების შეფერხებით
                    {"\n"}4.6 დანაკარგს, დაზიანებას ან ხარჯს, გამოწვეულს სატრანსპორტო საშუალების მფლობელის, მმართველის, მეფრახტის ან ოპერატორის გადახდის უუნარობით ან ფინანსური ვალებულების შეუსრულებლობით
                    {"\n"}4.7 დანაკარგს, დაზიანებას ან ხარჯს, გამოწვეულს ნებისმიერი საომარი იარაღის გამოყენებით, რომელიც მოიცავს ატომური ან ბირთვული დაშლის და/ან სინთეზის ან სხვა მსგავს რეაქციას ან რადიოაქტიურ ნივთიერებას ან გამოსხივებას.
                </Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>5.</Text>
                <Text>
                    არც ერთ შემთხვევაში ეს დაზღვევა არ დაფარავს დანაკარგს, დაზიანებას ან ხარჯს, გამოწვეულს გემის ან ხომალდის ნაოსნობისთვის გამოუსადეგარობით, გემის, ხომალდის, გადაზიდვის სხვა საშუალების, კონტეინერის ან სატვირთო ვაგონის შეუსაბამობით დაზღვეული ტვირთის უსაფრთხო გადაზიდვასთან იმ შემთხვევაში, როცა დაზღვეული ტვირთის მათში ჩატვირთვის დროისათვის დაზღვეულისათვის ან მისი მომსახურე პერსონალისათვის ცნობილია ასეთი გამოუსადეგარობის ან შეუსაბამობის შესახებ.
                </Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>6.</Text>
                <Text>
                    6.1 ომით, სამოქალაქო ომით, რევოლუციით, აჯანყებით, ამბოხებით ან მათგან წარმოშობილი სამოქალაქო დაპირისპირებით, ან დაპირისპირებული მხარეების მიერ განხორციელებული ნებისმიერი ძალადობითი ქმედებით.
                    {"\n"}6.2 შეპყრობით, კონფისკაციით, ყადაღით, გადაადგილების აკრძალვით ან დაკავებით (გარდა მეკობრეობისა) და მათგან გამომდინარე შედეგებით ან ამ ქმედებების ნებისმიერი მცდელობით.
                    {"\n"}6.3 მიტოვებული ნაღმებით, ტორპედოებით, ბომბებით ან სხვა მიტოვებული საომარი იარაღით.
                </Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 20 }}>
                <Text style={styles.clauseNumber}>7.</Text>
                <Text>
                    7.1 გამოწვეულს გაფიცულთა ქმედებებით, ლოკაუტირებული მუშებით, ან იმ პიროვნებების ქმედებით, რომლებიც იღებენ მონაწილეობას შრომით არეულობებში, აჯანყებაში ან სამოქალაქო მღელვარებაში.
                    {"\n"}7.2 გამოწვეულს გაფიცვებით, ლოკაუტით, შრომითი არეულობით, აჯანყებით ან სამოქალაქო მღელვარებით.
                    {"\n"}7.3 გამოწვეულს ნებისმიერი ტერორისტული ან პოლიტიკური მოტივით მოქმედი პიროვნების/ების მიერ.
                </Text>
            </View>

            <View style={styles.sectionTitle}>
                <Text>მოქმედების ვადა</Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>8.</Text>
                <Text>
                    8.1 წინამდებარე დაზღვევა იწყება იმ მომენტიდან, როდესაც ტვირთი ტოვებს საწყობს ან ხელშეკრულებით განსაზღვრულ შესანახ ადგილს გადაზიდვის დასაწყებად, გრძელდება დადგენილი (შეთანხმებული) მარშრუტით გადაზიდვის მთელი პერიოდის განმავლობაში და სრულდება:
                    {"\n"}8.1.1 როცა ტვირთი მიტანილი იქნება ტვირთის მიმღების საწყობში ან სხვა საბოლოო საწყობში ან/და საბოლოო შესანახ ადგილას, რომელიც მითითებული იქნება წინამდებარე ხელშეკრულებაში, ან
                    {"\n"}8.1.2 როცა ტვირთი მიტანილია ნებისმიერ სხვა საწყობში ან ნებისმიერ სხვა შესანახ ადგილას დანიშნულების საბოლოო ადგილზე მისვლამდე ან მისვლისას და რომელსაც დაზღვეული იყენებს:
                    {"\n"}8.1.2.1 შესანახად, განსხვავებით გადაზიდვის დადგენილი (შეთანხმებული) კურსისგან, ან
                    {"\n"}8.1.2.2 განსალაგებლად ან ცალკეულ პარტიებად შემდგომ გადასაზიდად,
                    {"\n"}8.1.3 საბოლოო ჩამოტვირთვის პორტში წინამდებარე პირობებით დაზღვეული ტვირთის ხომალდიდან ჩამოტვირთვიდან 60 დღის გასვლისას, იმის მიხედვით, თუ რომელი მოხდება უფრო ადრე.
                </Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>9.</Text>
                <Text>
                    თუ დაზღვეულის კონტროლის ფარგლებს მიღმა მოქმედი ფაქტორების გამო გადაზიდვის ხელშეკრულება შეწყდა გადაზიდვის საბოლოო დანიშნულების ადგილისაგან განსხვავებულ ადგილას ან განსხვავებულ პორტში, ან/და გადაზიდვა შეწყდა სხვაგვარად, ვიდრე ეს მოცემულია წინამდებარე პირობების მე-8 პუნქტში, მაშინ ეს დაზღვევაც დასრულდება, თუ მზღვეველს არ მიეწოდება სასწრაფო შეტყობინება და არ მოეთხოვება დაზღვევის გაგრძელება იმ დროისათვის, როდესაც ეს დაზღვევა არის ძალაში და მზღვეველი არ განაცხადებს თანხმობას დაზღვევის ხელშეკრულების გაგრძელების შესახებ.
                </Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>10.</Text>
                <Text>
                    თუ ამ დაზღვევის ძალაში შესვლის შემდეგ დაზღვეული შეცვლის დანიშნულების ადგილს, წინამდებარე დაზღვევა ძალაში დარჩება იმ პირობით, თუ მოხდება მზღვეველის დაუყოვნებლივ ინფორმირება და სადაზღვევო პრემიისა და პირობების შეთანხმება.
                </Text>
            </View>

            <View style={styles.sectionTitle}>
                <Text>სარჩელები</Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>11.</Text>
                <Text>
                    11.1 ამ დაზღვევით გათვალისწინებული ასანაზღაურებელი ზარალის მისაღებად დაზღვეულს უნდა გააჩნდეს დაზღვეული ობიექტის მიმართ დაზღვევის ინტერესი სადაზღვევო შემთხვევის დადგომის დროს.
                    {"\n"}11.2 წინამდებარე პირობების 11.1 პუნქტის თანახმად, დაზღვეულს ექნება უფლება, მიიღოს ამ დაზღვევის მოქმედების ვადის განმავლობაში მომხდარი ზიანის ანაზღაურება, იმის მიუხედავად, რომ ეს ზიანი შეიძლება მომხდარი ყოფილიყო დაზღვევის ძალაში შესვლამდე, გარდა იმ შემთხვევებისა, როდესაც დაზღვეულმა წინასწარ იცოდა ასეთი ზიანის შესახებ, ხოლო მზღვეველმა კი არა.
                </Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>12.</Text>
                <Text>
                    თუ ამ დაზღვევით დაფარული რისკის მოქმედების შედეგად, გადაზიდვა შეწყდა არა იმ პორტში ან დანიშნულების ადგილას, რომელიც გათვალისწინებულია სადაზღვევო პოლისით, მაშინ მზღვეველი აუნაზღაურებს დაზღვეულს ნებისმიერ დამატებით ხარჯებს, რაც მიზანშეწონილად და ჯეროვნად იქნა გაწეული ტვირთის ჩამოსატვირთად, შესანახად და გადასაგზავნად დანიშნულების იმ ადგილამდე, რომლამდეც ტვირთი იყო დაზღვეული.
                </Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>13.</Text>
                <Text>
                    ამ დაზღვევით არ მოხდება ”კონსტრუქციული სრული ზარალის” სარჩელის ანაზღაურება, გარდა იმ შემთხვევისა, როცა დაზღვეული ტვირთი, შესაბამისი გონივრული საფუძვლის არსებობისას, მიტოვებული იყო იმ მოსაზრებით, რომ მისი სრული დაღუპვა გარდაუვალი იქნებოდა, ან იმ მოსაზრებით რომ ტვირთის აღდგენის, შეკეთების და დანიშნულების საბოლოო ადგილამდე გადაზიდვის ღირებულება იქნებოდა ტვირთის ღირებულებაზე მეტი მისი დანიშნულების ადგილამდე ჩასვლის დროისათვის.
                </Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>14.</Text>
                <Text>
                    14.1 თუ წინამდებარე პირობებით დაზღვეული ტვირთი დაზღვეულია ასევე “გაზრდილი ღირებულების დაზღვევით”, მაშინ ჩაითვლება, რომ ტვირთის შეთანხმებული ღირებულება იზრდება საერთო თანხამდე, რომელშიც შედის წინამდებარე ხელშეკრულებით დადგენილი სადაზღვევო თანხა და გაზრდილი ღირებულების დაზღვევის სადაზღვევო თანხები, რომელიც ფარავს ზარალს; ასეთ შემთხვევაში სადაზღვევო ანაზღაურება იქნება პროპორციული წინამდებარე ხელშეკრულებით დადგენილი სადაზღვევო თანხისა და საერთო დაზღვეული თანხის შეფარდებისა;
                    {"\n"}14.2 თუ წინამდებარე დაზღვევა წარმოადგენს დაზღვევას, რომელიც ფარავს გაზრდილ ღირებულებას, ძალაში შედის შემდეგი მუხლი: ტვირთის შეთანხმებულ ღირებულებად ითვლება საერთო თანხა, რომელშიც შედის ძირითადი დაზღვევით განსაზღვრული სადაზღვევო თანხა და გაზრდილი ღირებულების დაზღვევით დადგენილი სადაზღვევო თანხა, რომელიც ფარავს ზარალს, ხოლო გასაცემი სადაზღვევო ანაზღაურება იქნება პროპორციული წინამდებარე ხელშეკრულებით დადგენილი სადაზღვევო თანხისა და საერთო დაზღვეული თანხის შეფარდებისა;
                </Text>
            </View>

            <View style={styles.sectionTitle}>
                <Text>სარგებლის მიუღებლობის პირობა</Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>15.</Text>
                <Text>
                    ეს დაზღვევა არ იმოქმედებს გადამზიდველის ან სხვა დეპოზიტორის (ტვირთის შენახვაზე პასუხისმგებელი პირი) სასარგებლოდ.
                </Text>
            </View>

            <View style={styles.sectionTitle}>
                <Text>ზარალის მინიმუმამდე დაყვანა</Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>16.</Text>
                <Text>
                    16.1 მიიღოს ზარალის თავიდან აცილების ან მისი მინიმუმამდე დაყვანის ყველა აუცილებელი გონივრული ზომები
                    {"\n"}16.2 მიიღოს ყველა შესაძლო ზომა გადამზიდველების, დეპოზიტორებისა (ანუ ტვირთის შენახვაზე პასუხისმგებელი პირის) ან სხვა მესამე მხარის წინააღმდეგ არსებული უფლებების დასაცავად და განსახორციელებლად
                </Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>17.</Text>
                <Text>
                    ზომები, რომლებიც მიღებულია დამზღვევის და მზღვეველის მიერ დაზღვეული ტვირთის გადარჩენის, დაცვის ან აღდგენის მიზნით, არ შეიძლება ჩაითვალოს, როგორც მხარეების უარი ან თანხმობა ტვირთის მიტოვებაზე (აბანდონზე)ან რომელიმე მხარის უფლების სხვაგვარ შეზღუდვაზე.
                </Text>
            </View>

            <View style={styles.sectionTitle}>
                <Text>სათანადო სისწრაფით მოქმედების პირობა</Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>18.</Text>
                <Text>
                    ამ დაზღვევის პირობაა, რომ დაზღვეული იმოქმედებს სათანადო სისწრაფით მისი კონტროლის ქვეშ მყოფ ნებისმიერ ვითარებაში.
                </Text>
            </View>

            <View style={styles.sectionTitle}>
                <Text>იურისდიქცია</Text>
            </View>

            <View style={{ flexDirection: "row", marginBottom: 10 }}>
                <Text style={styles.clauseNumber}>19.</Text>
                <Text>
                    წინამდებარე დაზღვევიდან წარმოშობილი ნებისმიერი ურთიერთობა რეგულირდება საქართველოს სამართლით.
                </Text>
            </View>

            <View style={{ marginTop: 30 }}>
                <Text style={{ fontFamily: 'HelveticaBold' }}>შენიშვნა:</Text>
                <Text>
                    როდესაც დაზღვეული შეიტყობს ამ დაზღვევით დაზღვეული შემთხვევის დადგომის შესახებ, მან აუცილებლად დაუყოვნებლივ უნდა მიაწოდოს სასწრაფო შეტყობინება მზღვეველს და ასეთი ზარალის ანაზღაურების უფლება დამოკიდებულია ამ ვალდებულების შესრულებაზე.
                </Text>
            </View>

            <View style={{ marginTop: 30 }}>
                <Text style={{ fontFamily: 'HelveticaBold' }}>წინამდებარე ტექსტი წარმოადგენს თანგმანს ინგლისური ტექსტიდან INSTITUTE CARGO CLAUSES (A) 1/1/82. ამ პირობების განმარტებისას მხარეთა უთანხმოების შემთხვევაში უპირატესობა ენიჭება ორიგინალურ ინგლუსურ ვარიანტს.</Text>
            </View>
        </Page>
    </Document>
);

const LondonUnderWriters = () => {
    const {t} = useTranslation();
    
    const generatePDF = async () => {
        const blob = await pdf(<MyDocument />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.click();
    };

    return (
        <span className={cl.btn} onClick={generatePDF}>
            <PDFicon /> {t('InsuranceConditions')}
        </span>
   
    );
};

export default LondonUnderWriters;